'use strict'

/**
 * Хранилище всех имен view, доступных для роутинга
 */

export const VIEWS = {
  init: createView('init', 'Init'),
  load: createView('load', 'Load'),
  error: createView('error', 'Error'),
  receipt: createView('receipt', 'Receipt')
}

function createView(type, name) {
  return {
    moduleType: type,
    name: name
  }
}
